import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the HTML was prerendered (SSG via scripts/prerender.mjs), hydrate instead
// of re-rendering — preserves SEO HTML and makes the page interactive.
if (document.documentElement.getAttribute("data-prerendered") === "true") {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
